import React from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import PropTypes from 'prop-types';
import { Button, Alert } from 'antd';

import Input from '../../components/form/Input';
import Select from '../../components/form/Select';
import { required, validatePhone } from '../../components/form/validation';
import DB_CONST from '../../config/db_const';

import s from './profile.less';

class Profile extends React.Component {
  static propTypes = {
    change: PropTypes.func,
    error: PropTypes.any,
  };
  state = {
    success: false,
    counties: [],
  };
  async componentDidMount() {
    const counties = await fetch(`${DB_CONST.apiUrl}/location/counties`);
    this.setState({
      counties: counties.map(x => ({ value: x.id.toString(), text: x.value })),
    });

    const data = await fetch('/provider/profile');
    const { CountyId } = data;
    delete data.CountyId;
    Object.entries(data.fields).forEach(x => {
      this.props.change(x[0], x[1]);
    });
    this.props.change('CountyId', counties.find(x => +x.id === CountyId));
  }
  submit = async values => {
    this.setState({ success: false });
    try {
      await fetch(`${DB_CONST.apiUrl}/api/location/postcode/check`, {
        method: 'post',
        body: { postcode: values.postcode },
      });
    } catch (e) {
      throw new SubmissionError({
        postcode: /Postcode isn't valid/.test(e.error)
          ? 'Postcode not valid'
          : e.error,
      });
    }
    try {
      await fetch('/provider/profile', { method: 'post', body: values });
    } catch (e) {
      throw new SubmissionError({ _error: e.error });
    }
    this.setState({ success: true });
  };
  render() {
    return (
      <form onSubmit={this.props.handleSubmit(this.submit)} className={s.form}>
        <Field
          placeholder="Firs name"
          name="firstName"
          component={Input}
          validate={required}
        />
        <Field
          placeholder="Last name"
          name="lastName"
          component={Input}
          validate={required}
        />
        <Field
          placeholder="E-mail"
          name="email"
          type="email"
          component={Input}
          validate={required}
        />
        <Field
          placeholder="Phone"
          name="phone"
          component={Input}
          validate={[required, validatePhone]}
        />
        <Field
          placeholder="Address line 1"
          name="addressLine1"
          component={Input}
          validate={required}
        />
        <Field
          placeholder="Address line 2"
          name="addressLine2"
          component={Input}
          validate={required}
        />
        <Field
          placeholder="City"
          name="city"
          component={Input}
          validate={required}
        />
        <Field
          name="CountyId"
          component={Select}
          validate={required}
          options={this.state.counties}
        />
        <Field
          placeholder="Postcode"
          name="postcode"
          component={Input}
          validate={required}
        />
        <Button htmlType="submit" type="primary">
          Update
        </Button>
        {this.props.error && <Alert message={this.props.error} type="error" />}
        {this.state.success && (
          <Alert message="Profile has been saved successfully" type="success" />
        )}
      </form>
    );
  }
}

Profile.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'provider-profile',
})(Profile);
